import React, {useEffect, useRef, useState} from 'react';
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import {gsap, ScrollTrigger} from 'gsap/all';
import Footer from '../components/footer/Footer';
import Preloader from '../components/preloader/Preloader';
import ScrollTriggerProxy from '../components/ScrollTriggerProxy';

const PageLayout = ({children, className, bodyClassName}) => {
  gsap.registerPlugin(ScrollTrigger);
    const [resize, setResize] = useState(false); 
    const {scroll} = useLocomotiveScroll(); 
    
    if(scroll){
      scroll.scrollTo(0, { duration: 0, disableLerp: true }); 
      scroll.update();
    }
    if(bodyClassName){
      document.body.classList.add(...bodyClassName);
    }

    useEffect(() => {

      ScrollTrigger.refresh();

      let timeOut;
      const winResize = ()=>{  
        setResize(true)
        if(timeOut) clearTimeout(timeOut);
        setTimeout(()=> setResize(false), 1500); 
      }
  
      window.addEventListener("resize", winResize); 

      return ()=>{
        window.removeEventListener("resize", winResize);
        if(bodyClassName){
          document.body.classList.remove(...bodyClassName); 
        }
        if(scroll){
          scroll.scrollTo(0, { duration: 0, disableLerp: true }); 
          scroll.update(); 
        }
        ScrollTrigger.refresh(); 
      }
    }, [resize]);

    return (
        <div className={`${className ? className : ""}`}>
                {resize && (<Preloader></Preloader>)} 
                {!resize && (
                    <>
                        <ScrollTriggerProxy/>
                        {children} 
                        <Footer/>
                    </>
                )}
        </div>
    );
}

export default PageLayout;
